import React from 'react';
import { TableRow, TableCell, Typography, Box } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const EmptyTableBody = ({ colSpan, message }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          gap={1}
          color="text.secondary"
        >
          <SearchOffIcon sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h6" gutterBottom>
            {message || "No records found"}
          </Typography>
          <Typography variant="body2" color="text.secondary" maxWidth={400} textAlign="center">
            If you are using filters, please clear them and try again.
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default EmptyTableBody;